import Types from '@Types';

const reducer = (state = [], action) => {
    switch (action.type) {
        //? inset PrintCustomization
        case Types.PrintCustomization.insert:
            if (state.some(x => x.Series === action.payload.value.Series))
                return state
            else return [action.payload.value, ...state];
        //? update PrintCustomization
        case Types.PrintCustomization.update:
            return [
                ...state.map((x) => {
                    if (x.Series === action.payload.Series) return action.payload.value;
                    else return x;
                }),
            ];
        //? delete PrintCustomization
        case Types.PrintCustomization.delete:
            return [...state.filter((x) => x.Series !== action.payload.Series)];
        // ? clear all data
        case Types.clear:
            return [];
        //? set PrintCustomization
        case Types.PrintCustomization.set:
            return action.payload ?? [];
        // ? default
        default:
            return state;
    }
};

export default reducer;
